export default "__VITE_ASSET__CACbbvNl__"